import { useEffect } from 'preact/compat'
import { useDispatch, useSelector } from 'react-redux'
import { addQueryParams, replaceAll } from '../helpers/common'
import { transactionDetailsUpdate } from '../redux/slice/transactionDetailsSlice'
import { prepareTranslations } from '../sagas/transactionDetails'
import translatinAdapter from '../helpers/translations'

export default function useCulture(lang) {
  const dispatch = useDispatch()
  const transactionDetails = useSelector(state => state.transactionDetails)
  const { successUrl, failureUrl, timeoutUrl } = transactionDetails

  useEffect(() => {
    let mappedLang = transactionDetails.culture
    if (lang && transactionDetails.culture !== lang) {
      mappedLang = replaceAll(lang, '_', '-')
      if (!transactionDetails?.tenantId) return

      const translations = window.tuiPaymentTranslations?.[
        transactionDetails.tenantId
      ]
        ? prepareTranslations(transactionDetails.tenantId)
        : window.tuiPaymentTranslations?.default

      translatinAdapter.setTranslations(translations, lang)

      dispatch(transactionDetailsUpdate({ culture: mappedLang }))
    }

    if (transactionDetails.culture) {
      dispatch(
        transactionDetailsUpdate({
          successUrl: successUrl
            ? addQueryParams(successUrl, {
                locale: mappedLang,
              })
            : null,
          failureUrl: failureUrl
            ? addQueryParams(failureUrl, {
                locale: mappedLang,
              })
            : null,
          timeoutUrl: timeoutUrl
            ? addQueryParams(timeoutUrl, {
                locale: mappedLang,
              })
            : null,
        }),
      )
    }
  }, [lang, transactionDetails.culture, transactionDetails.tenantId])
}
